<script>
	import IconRemove from '../../icons/IconRemove.svelte';
	import { getIkResponseData, getSelectedImage, uploadToImageKit } from '../../utils';

	import { seoOgTwitterImage } from '../../stores/seo/SeoStore';
	import { seoOgTwitterImageDefault } from '../../stores/seo/SeoStoreDefaults';
	import { updateSeoOgTwitterImage } from '../../stores/seo/UpdateSeoOgTwitterImage';

	let seoOgTwitterImageValue;
	let file;
	let isBusy = false;

	seoOgTwitterImage.subscribe((value) => {
		seoOgTwitterImageValue = value;
	});

	const onClear = () => {
		updateSeoOgTwitterImage(seoOgTwitterImageDefault);
	};

	const onImageChange = async (e) => {
		file = getSelectedImage(e);
		if (!file) {
			return;
		}
		try {
			const ikResponse = await uploadToImageKit(file, file.name);
			updateSeoOgTwitterImage(getIkResponseData(file, ikResponse));
		} catch (err) {
			console.log('OG Image change error - ', err);
			return;
		}
	};
</script>

<div class="proteus-control proteus-group">
	<label for="seo-og-twitter-image-file" class="proteus-file-zone">
		<span class="proteus-file-zone-name">
			{file || seoOgTwitterImageValue?.upload?.url ? 'Change OG Twitter Image' : 'Select OG Twitter Image'}
		</span>
		<input
			type="file"
			on:input={onImageChange}
			name="seo-og-twitter-image"
			id="seo-og-twitter-image-file"
			disabled={isBusy}
			class="proteus-file-zone-file"
		/>
		{#if file || seoOgTwitterImageValue?.upload?.url}
			<span on:click|preventDefault={onClear} class="proteus-file-zone-remove">
				<IconRemove />
			</span>
		{/if}
	</label>
</div>
